define('lq/runtimeDispatcher',[
    'jquery',
    'lq',
    'underscore',
    'when',
    'lq/ajax',
    'lq/deviceId'
], function ($, lq, _, when, ajax, deviceId) {
    'use strict';

    var lastResultMaxLength = 200;
    var lastResponse = undefined;
    var replaceLastResponse = function(responseText, status) {
        lastResponse = {
            status: status,
            responseText: responseText && responseText.length > lastResultMaxLength
                ? responseText.substring(0, lastResultMaxLength) + '...'
                : responseText
        };
    };

    var getCsrfToken = function () {
        return $('input[name="__RequestVerificationToken"]', $('#__AjaxAntiForgeryForm')).val();
    };

    var RuntimeDispatcher = function (busyIndicator, actionVersion, masterPageVersion, runtime) {
        this.busyIndicator = busyIndicator;
        this.actionVersion = actionVersion;
        this.masterPageVersion = masterPageVersion;
        this.csrfToken = getCsrfToken();
        this.requests = [];
        this.runtime = runtime;
    };

    RuntimeDispatcher.getDescriptionOfLastResponse = function() {
        return lastResponse
            ? lastResponse.status + ' - ' + lastResponse.responseText
            : undefined;
    };

    RuntimeDispatcher.prototype.dispatch = function (url, data, success, options, error, doNotHandleUnauthorized) {
        url = lq.getTenantUrl(url);
        return this.dispatchToAbsoluteUrl(url, data, success, options, error, doNotHandleUnauthorized);
    };

    RuntimeDispatcher.prototype.dispatchToAbsoluteUrl = function (absoluteUrl, data, success, options, error, doNotHandleUnauthorized) {
        data = data || {};
        success = success || $.noop;
        error = error || $.noop;
        doNotHandleUnauthorized = doNotHandleUnauthorized || false;
        var successFunc = function (result) {
            success(result);
        };
        var errorFunc = function (jqxhr) {
            // Automatically reload the page if we get a 401
            // when making a call to the url of the current tenant.
            // In all other cases (e.g. the annotations integrations)
            // the calling code should handle this.
            //
            // Note that this is not the best way to handle this
            // (the user will briefly see an error dialog), cause
            // we're using a mix of callbacks and promises
            if (jqxhr && jqxhr.status === 401 && absoluteUrl.indexOf(lq.getTenantUrl('')) === 0 && !doNotHandleUnauthorized) {
                window.location.reload();
            } else {
                try {
                    error();
                } catch { }
            }
        };
        options = options || {};

        this.busyIndicator.show();
        return this.doDispatch(absoluteUrl, data, successFunc, errorFunc, options);
    };

    RuntimeDispatcher.prototype.backgroundDispatch = function (url, data, success, options, error) {
        url = lq.getTenantUrl(url);
        return this.doDispatch(url, data || {}, success || $.noop, error || $.noop, options || {});
    };

    RuntimeDispatcher.prototype.doDispatch = function (url, data, successFunc, errorFunc, options) {
        var headers = options.headers || {};

        headers.LicquidActionVersion = this.actionVersion;
        headers.LicquidMasterPageVersion = this.masterPageVersion;
        headers.LicquidDeviceId = deviceId.get();

        if (this.csrfToken)
            headers['__RequestVerificationToken'] = this.csrfToken;

        var self = this;
        var payload = data;
        var requestOptions = $.extend(
            {
                url: url,
                type: 'POST',
                cache: false,
                data: JSON.stringify(payload),
                dataType: 'json',
                contentType: "application/json; charset=utf-8",
                headers: headers,
                beforeSend: function(jqXHR) {
                    self.requests.push(jqXHR);
                },
                success: function (data, status, jqXHR) {
                    replaceLastResponse(jqXHR.responseText, jqXHR.status);

                    if (data.status === "VersionMismatch") {
                        self.runtime.reloadAction();
                    } else {
                        self.cleanUpRequest(jqXHR);
                        successFunc(data, status, jqXHR);
                    }
                },
                error: function(jqXHR, textStatus)  {
                    replaceLastResponse(jqXHR.responseText, jqXHR.status);

                    self.cleanUpRequest(jqXHR);

                    if(textStatus === 'abort') return;
                    errorFunc(jqXHR);
                    if (jqXHR && jqXHR.getResponseHeader('reason_of_failing') === 'maintenance_mode_turned_on') {
                        window.location.reload();
                    }
                }
            },
            options);

        return when(ajax.withRetry(requestOptions));
    };

    RuntimeDispatcher.prototype.getMessageFromResponse = function (jqxhr) {
        var response;
        try {
            response = JSON.parse(jqxhr.responseText);
        }
        catch (ignore) { }
        return response && response.message;
    };

    RuntimeDispatcher.prototype.cleanUpRequest = function (jqXHR) {
        this.requests = _.without(this.requests, jqXHR);
        this.busyIndicator.hide();
    };

    RuntimeDispatcher.prototype.refreshCsrfToken = function (callback) {
        var self = this;
        $.get(lq.getTenantUrl('LicquidAction/GetCsrfToken'), function (data) {
            self.csrfToken = $(data).val();
            callback();
        });
    };

    RuntimeDispatcher.prototype.cleanUp = function () {
        _.each(this.requests, function (request) {
            request.abort();
        });
    };

    return RuntimeDispatcher;
});
